"use client";

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { retrieveKycList } from "../../redux/actions/users";
import { checkValidation, formatMessageTime } from "../../helpers/Helper";
import DataTable from "react-data-table-component";
import CustomLoaderComponent from "../Common/Loader/Loader";
import IconContainer from "../Common/IconContainer";
import { FaEye } from "react-icons/fa";

export default function UserVerificationList() {
  const router = useNavigate();
  const dispatch = useDispatch();
  const { kycData, loadingKycData } = useSelector((state) => state.user);
  const [page, setPage] = React.useState(1);
  const [perPage, setPerPage] = React.useState(100);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");

  console.log("=================", kycData);

  const handleUserClick = React.useCallback(
    (kycId) => {
      router(`/user/kyc/${kycId}`);
    },
    [router]
  );

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleTypeFilterChange = (e) => {
    setTypeFilter(e.target.value);
  };

  React.useEffect(() => {
    dispatch(retrieveKycList({ page, perPage, keyword: searchTerm }));
  }, [dispatch, page, perPage, searchTerm]);

  const columns = React.useMemo(() => {
    const commonColumns = [
      // {
      //   name: "User ID",
      //   selector: (row) => checkValidation(row.publicId),
      //   width: "150px",
      //   headerStyle: { textAlign: "center" },
      // },
      {
        name: "Name",
        width: "200px",
        selector: (row) => checkValidation(row.firstName + "  " + row.lastName),
        headerStyle: { textAlign: "center" },
      },
      {
        name: "username",
        width: "180px",
        selector: (row) => checkValidation(row.username),
        headerStyle: { textAlign: "center" },
        cell: (row) => {
          return (
            <>
              <span className={`statusBadge `}>
                {row?.username &&
                  row?.username?.charAt(0)?.toUpperCase() +
                    row?.username?.slice(1)}
              </span>
            </>
          );
        },
      },
      {
        name: "Email",
        width: "250px",
        selector: (row) => checkValidation(row.email),
        headerStyle: { textAlign: "center" },
      },
      {
        name: "Submitted ",
        headerStyle: {
          textAlign: "right",
        },
        width: "250px",
        selector: (row) => checkValidation(row.govtIdSubmittedAt),

        cell: (row) => (
          <>
            {checkValidation(row.govtIdSubmittedAt) !== "N/A"
              ? formatMessageTime(row.govtIdSubmittedAt)
              : "N/A"}
          </>
        ),
      },
      {
        name: "Type",
        width: "120px",
        selector: (row) => checkValidation(row.accountType),
        headerStyle: { textAlign: "center" },
        cell: (row) => (
          <>
            <span
              className={`${"typeLabel"} ${
                row.accountType === "business"
                  ? "businessType"
                  : "individualType"
              }`}
            >
              {row.accountType.charAt(0).toUpperCase() +
                row.accountType.slice(1)}
            </span>
          </>
        ),
      },
      {
        name: "Status",
        width: "150px",
        selector: (row) => checkValidation(row.createdAt),
        headerStyle: { textAlign: "center" },
        cell: (row) => {
          let status = "pending";
          // if (row?.govtIdVerifiedAt !== null && row?.isGovIdVerified === 0) {
          //   status = "rejected";
          // } else if (
          //   row?.govtIdVerifiedAt !== null &&
          //   row?.isGovIdVerified === 1
          // ) {
          //   status = "approved";
          // }
          return (
            <>
              <span className={`statusBadge ${status}`}>
                {status?.charAt(0).toUpperCase() + status?.slice(1)}
              </span>
            </>
          );
        },
      },
    ];
    const renderActionCell = (row) => {
      return (
        <>
          <IconContainer
            Icon={FaEye}
            handleOnClick={() => handleUserClick(row.publicId)}
            text="View"
          />
        </>
      );
    };
    return [
      ...commonColumns,
      {
        name: "Actions",
        button: true,
        minWidth: "150px",
        headerStyle: { textAlign: "center" },
        cell: renderActionCell,
      },
      {
        name: "Rejection Count",
        width: "180px",
        selector: (row) => checkValidation(row.rejectionCount),
        headerStyle: { textAlign: "center" },
        cell: (row) => {
          return (
            <>
              <span className={`statusBadge `}>{row?.rejectionCount}</span>
            </>
          );
        },
      },
    ];
  }, [handleUserClick]);

  const handlePageChange = (page) => {
    setPage(page);
  };

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
  };
  return (
    <div className={"listContainer"}>
      <header className={"listHeader"}>
        <h1>KYC Verification Management</h1>
        <p>Review and manage user verification submissions</p>
      </header>

      <div className={"controlsContainer"}>
        <div className={"searchContainer"}>
          <input
            type="text"
            placeholder="Search by name, email, or ID..."
            value={searchTerm}
            onChange={handleSearchChange}
            className={"searchInput"}
          />
        </div>

        <div className={"filtersContainer"}>
          <div className={"filterGroup"}>
            <label htmlFor="statusFilter">Status:</label>
            <select
              id="statusFilter"
              value={statusFilter}
              onChange={handleStatusFilterChange}
            >
              <option value="all">All Statuses</option>
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>

          <div className={"filterGroup"}>
            <label htmlFor="typeFilter">Type:</label>
            <select
              id="typeFilter"
              value={typeFilter}
              onChange={handleTypeFilterChange}
            >
              <option value="all">All Types</option>
              <option value="individual">Individual</option>
              <option value="business">Business</option>
            </select>
          </div>
        </div>
      </div>

      {/* <div className={"tableContainer"}>
            <table className={"usersTable"}>
              <thead>
                <tr>
                  <th onClick={() => handleSort("id")} className={"sortableHeader"}>
                    User ID
                    {sortConfig.key === "id" && (
                      <span className={"sortIcon"}>
                        {sortConfig.direction === "asc" ? " ↑" : " ↓"}
                      </span>
                    )}
                  </th>
                  <th
                    onClick={() => handleSort("name")}
                    className={"sortableHeader"}
                  >
                    Name
                    {sortConfig.key === "name" && (
                      <span className={"sortIcon"}>
                        {sortConfig.direction === "asc" ? " ↑" : " ↓"}
                      </span>
                    )}
                  </th>
                  <th
                    onClick={() => handleSort("email")}
                    className={"sortableHeader"}
                  >
                    Email
                    {sortConfig.key === "email" && (
                      <span className={"sortIcon"}>
                        {sortConfig.direction === "asc" ? " ↑" : " ↓"}
                      </span>
                    )}
                  </th>
                  <th
                    onClick={() => handleSort("submittedAt")}
                    className={"sortableHeader"}
                  >
                    Submitted
                    {sortConfig.key === "submittedAt" && (
                      <span className={"sortIcon"}>
                        {sortConfig.direction === "asc" ? " ↑" : " ↓"}
                      </span>
                    )}
                  </th>
                  <th
                    onClick={() => handleSort("verificationType")}
                    className={"sortableHeader"}
                  >
                    Type
                    {sortConfig.key === "verificationType" && (
                      <span className={"sortIcon"}>
                        {sortConfig.direction === "asc" ? " ↑" : " ↓"}
                      </span>
                    )}
                  </th>
                  <th
                    onClick={() => handleSort("status")}
                    className={"sortableHeader"}
                  >
                    Status
                    {sortConfig.key === "status" && (
                      <span className={"sortIcon"}>
                        {sortConfig.direction === "asc" ? " ↑" : " ↓"}
                      </span>
                    )}
                  </th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.length > 0 ? (
                  currentUsers.map((user) => (
                    <tr
                      key={user.id}
                      onClick={() => handleUserClick(user.kycId)}
                      className={"userRow"}
                    >
                      <td>{user.id}</td>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>{formatDate(user.submittedAt)}</td>
                      <td>
                        <span
                          className={`${"typeLabel"} ${
                            user.verificationType === "business"
                              ? "businessType"
                              : "individualType"
                          }`}
                        >
                          {user.verificationType.charAt(0).toUpperCase() +
                            user.verificationType.slice(1)}
                        </span>
                      </td>
                      <td>
                        <span className={`${"statusBadge"} ${[user.status]}`}>
                          {user.status.charAt(0).toUpperCase() +
                            user.status.slice(1)}
                        </span>
                      </td>
                      <td>
                        <button
                          className={"viewButton"}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleUserClick(user.kycId);
                          }}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className={"noResults"}>
                      No users found matching your filters
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div> */}

      <DataTable
        className="rdt_Wrapper"
        columns={columns}
        data={kycData?.data}
        pagination
        paginationServer
        progressPending={loadingKycData}
        progressComponent={<CustomLoaderComponent width="10vw" height="50vh" />}
        paginationTotalRows={kycData?.pagination?.totalItems}
        paginationDefaultPage={page}
        paginationPerPage={perPage}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        paginationRowsPerPageOptions={[100, 150, 200]}
        // subHeader
        // subHeaderComponent={subHeaderComponent}
        // paginationRowsPerPageOptions={paginationOptions}
      />

      <div className={"resultsInfo"}>
        Showing {kycData?.data?.length} of {kycData?.pagination?.totalItems}{" "}
        results
      </div>
    </div>
  );
}
